import { Role } from 'src/types';

// Reusable role groups — the single source of truth for every route's
// allowList. Both `RootRouter` (route guards) and `Sidebar` (menu config)
// must read from `routeAccess` so the guard and the menu can never drift
// (a menu item showing a route the guard denies, or vice-versa).
const SUPER_SUPPORT: Role[] = [Role.SuperAdmin, Role.Support];
const ANALYST_UP: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst];
const CONFIG_ADMINS: Role[] = [
  Role.SuperAdmin,
  Role.Support,
  Role.Analyst,
  Role.ClientAdmin,
  Role.EmployerAdmin,
];
const DATA_ADMINS: Role[] = [
  Role.SuperAdmin,
  Role.Support,
  Role.Analyst,
  Role.ClientAdmin,
  Role.Manager,
  Role.EmployerAdmin,
];

// Keys correspond to `RoutePath` members. Lookups are membership-based, so
// array order is not significant for guard/menu behaviour.
export const routeAccess = {
  // Top-level guarded branches (consumed by RootRouter)
  configurationRoot: CONFIG_ADMINS,
  dataManagementRoot: DATA_ADMINS,
  reportingRoot: DATA_ADMINS,
  productInfo: SUPER_SUPPORT,

  // Configuration — children
  configurationGeneralSettingsRoot: ANALYST_UP,
  configurationSchemeRoot: ANALYST_UP,

  // Reporting — children
  reportingTemplatesRoot: CONFIG_ADMINS,
};
